export const LOAD_SHIFTS = 'LOAD_SHIFTS';
export const SHIFTS_SUCCESS = 'SHIFT_SUCCESS';
export const SHIFTS_FAILURE = 'SHIFT_FAILURE';

export const LOAD_TRACKING = 'LOAD_TRACKING';
export const TRACKING_SUCCESS = 'TRACKING_SUCCESS';
export const TRACKING_FAILURE = 'TRACKING_FAILURE';

export const LOAD_JOB = 'LOAD_JOB';
export const LOAD_JOB_SUCCESS = 'LOAD_JOB_SUCCESS';
export const LOAD_JOB_FAILURE = 'LOAD_JOB_FAILURE';

export const LOAD_TRACKING_MAP_DATA = 'LOAD_TRACKING_MAP_DATA';
export const TRACKING_MAP_DATA_FAILURE = 'TRACKING_MAP_DATA_FAILURE';
export const TRACKING_MAP_DATA_SUCCESS = 'TRACKING_MAP_DATA_SUCCESS';

export const JOB_INVITATIONS = 'JOB_INVITATIONS';
export const JOB_INVITATIONS_SUCCESS = 'JOB_INVITATIONS_SUCCESS';
export const JOB_INVITATIONS_FAILURE = 'JOB_INVITATIONS_FAILURE';

export const SEND_SHIFT = 'SEND_SHIFT';
export const SEND_SHIFT_SUCCESS = 'SEND_SHIFT_SUCCESS';
export const SEND_SHIFT_FAILURE = 'SEND_SHIFT_FAILURE';
export const SHIFTS_SELECTED = 'SHIFTS_SELECTED';

export const CANCEL_SHIFTS = 'CANCEL_SHIFTS';
export const CANCEL_SHIFTS_FAILURE = 'CANCEL_SHIFTS_FAILURE';
export const CANCEL_SHIFTS_SUCCESS = 'CANCEL_SHIFTS_SUCCESS';

export const LOAD_SUBSCRIPTIONS = 'LOAD_SUBSCRIPTIONS';
export const LOAD_SUBSCRIPTIONS_SUCCESS = 'LOAD_SUBSCRIPTIONS_SUCCESS';
export const LOAD_SUBSCRIPTIONS_FAILURE = 'LOAD_SUBSCRIPTIONS_FAILURE';

export const ACCEPT_INVITATION = 'ACCEPT_INVITATION';
export const REJECT_INVITATION = 'REJECT_INVITATION';

export const LOAD_BOOKINGS = 'LOAD_BOOKINGS';
export const LOAD_BOOKINGS_SUCCESS = 'LOAD_BOOKINGS_SUCCESS';
export const LOAD_BOOKINGS_FAILURE = 'LOAD_BOOKINGS_FAILURE';

export const LOAD_FREELANCERS = 'LOAD_FREELANCERS';
export const LOADED_FREELANCERS_SUCCESS = 'LOADED_FREELANCERS_SUCCESS';
export const LOADED_FREELANCERS_FAILURE = 'LOADED_FREELANCERS_FAILURE';

export const LOAD_UNALLOCATED_FREELANCERS = 'LOAD_UNALLOCATED_FREELANCERS';
export const LOADED_UNALLOCATED_FREELANCERS_SUCCESS = 'LOADED_UNALLOCATED_FREELANCERS_SUCCESS';
export const LOADED_UNALLOCATED_FREELANCERS_FAILURE = 'LOADED_UNALLOCATED_FREELANCERS_FAILURE';

export const LOAD_CLIENTS = 'LOAD_CLIENTS';
export const LOADED_CLIENTS_SUCCESS = 'LOADED_CLIENTS_SUCCESS';
export const LOADED_CLIENTS_FAILURE = 'LOADED_CLIENTS_FAILURE';

export const UPLOAD_FREELANCERS = 'UPLOAD_FREELANCERS';
export const UPLOAD_FREELANCERS_SUCCESS = 'UPLOAD_FREELANCERS_SUCCESS';
export const UPLOAD_FREELANCERS_FAILURE = 'UPLOAD_FREELANCERS_FAILURE';

export const CREATE_FREELANCERS = 'CREATE_FREELANCERS';
export const CREATE_FREELANCERS_RESET = 'CREATE_FREELANCERS_RESET';
export const CREATE_FREELANCERS_SUCCESS = 'CREATE_FREELANCERS_SUCCESS';
export const CREATE_FREELANCERS_FAILURE = 'CREATE_FREELANCERS_FAILURE';

export const SEND_SMS = 'SEND_SMS';
export const SEND_SMS_SUCCESS = 'SEND_SMS_SUCCESS';
export const SEND_SMS_FAILURE = 'SEND_SMS_FAILURE';

export const SEND_NOTIFICATION = 'SEND_NOTIFICATION';
export const SEND_NOTIFICATION_SUCCESS = 'SEND_NOTIFICATION_SUCCESS';
export const SEND_NOTIFICATION_FAILURE = 'SEND_NOTIFICATION_FAILURE';

export const LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS';
export const LOAD_NOTIFICATIONS_SUCCESS = 'LOAD_NOTIFICATIONS_SUCCESS';
export const LOAD_NOTIFICATIONS_FAILURE = 'LOAD_NOTIFICATIONS_FAILURE';
export const LOAD_NOTIFICATIONS_COUNTERS = 'LOAD_NOTIFICATIONS_COUNTERS';
export const LOAD_NOTIFICATIONS_COUNTERS_SUCCESS =
    'LOAD_NOTIFICATIONS_COUNTERS_SUCCESS';
export const OPEN_NOTIFICATIONS = 'OPEN_NOTIFICATIONS';
export const CLOSE_NOTIFICATIONS = 'CLOSE_NOTIFICATIONS';

export const AUTHENTICATED_USER = 'AUTHENTICATED_USER';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const AGENT_LOGGED_IN = 'AGENT_LOGGED_IN';
export const CLIENT_LOGGED_IN = 'CLIENT_LOGGED_IN';
export const FREELANCER_LOGGED_IN = 'FREELANCER_LOGGED_IN';

export const SET_SELECTED_JOBS = 'SET_SELECTED_JOBS';
export const SET_SELECTED_FREELANCERS = 'SET_SELECTED_FREELANCERS';
export const SET_SELECTED_UNALLOCATED_FREELANCERS = 'SET_SELECTED_UNALLOCATED_FREELANCERS';

export const CREATE_MASS_BOOKING = 'CREATE_MASS_BOOKING';
export const CREATE_MASS_BOOKING_SUCCESS = 'CREATE_MASS_BOOKING_SUCCESS';
export const CREATE_MASS_BOOKING_FAILURE = 'CREATE_MASS_BOOKING_FAILURE';

export const LOAD_INDUCTION_SESSIONS = 'LOAD_INDUCTION_SESSIONS';
export const LOAD_INDUCTION_SESSIONS_SUCCESS = 'LOAD_INDUCTION_SESSIONS_SUCCESS';
export const LOAD_INDUCTION_SESSIONS_FAILURE = 'LOAD_INDUCTION_SESSIONS_FAILURE';

const actionOf = (type, payload) => ({
    type,
    payload,
});

const actions = {
    authenticatedUser: data => actionOf(AUTHENTICATED_USER, data),
    userLoggedOut: data => actionOf(USER_LOGGED_OUT, data),
    agentLoggedIn: data => actionOf(AGENT_LOGGED_IN, data),
    clientLoggedIn: data => actionOf(CLIENT_LOGGED_IN, data),
    freelancerLoggedIn: data => actionOf(FREELANCER_LOGGED_IN, data),

    loadFreelancers: data => actionOf(LOAD_FREELANCERS, data),
    loadFreelancerSuccess: data => actionOf(LOADED_FREELANCERS_SUCCESS, data),
    loadFreelancerFailure: data => actionOf(LOADED_FREELANCERS_FAILURE, data),

    loadUnallocatedFreelancers: data => actionOf(LOAD_UNALLOCATED_FREELANCERS, data),
    loadUnallocatedFreelancerSuccess: data => actionOf(LOADED_UNALLOCATED_FREELANCERS_SUCCESS, data),
    loadUnallocatedFreelancerFailure: data => actionOf(LOADED_UNALLOCATED_FREELANCERS_FAILURE, data),

    loadClients: data => actionOf(LOAD_CLIENTS, data),
    loadClientsSuccess: data => actionOf(LOADED_CLIENTS_SUCCESS, data),
    loadClientsFailure: data => actionOf(LOADED_CLIENTS_FAILURE, data),

    uploadFreelancers: data => actionOf(UPLOAD_FREELANCERS, data),
    uploadFreelancersSuccess: data =>
        actionOf(UPLOAD_FREELANCERS_SUCCESS, data),
    uploadFreelancersFailure: data =>
        actionOf(UPLOAD_FREELANCERS_FAILURE, data),

    createFreelancers: data => actionOf(CREATE_FREELANCERS, data),
    createFreelancersReset: data => actionOf(CREATE_FREELANCERS_RESET, data),
    createFreelancersSuccess: data =>
        actionOf(CREATE_FREELANCERS_SUCCESS, data),
    createFreelancersFailure: data =>
        actionOf(CREATE_FREELANCERS_FAILURE, data),

    sendSMS: data => actionOf(SEND_SMS, data),
    sendSMSSuccess: data => actionOf(SEND_SMS_SUCCESS, data),
    sendSMSFailure: data => actionOf(SEND_SMS_FAILURE, data),

    sendNotification: data => actionOf(SEND_NOTIFICATION, data),
    sendNotificationSuccess: data => actionOf(SEND_NOTIFICATION_SUCCESS, data),
    sendNotificationFailure: data => actionOf(SEND_NOTIFICATION_FAILURE, data),

    loadShifts: data => actionOf(LOAD_SHIFTS, data),
    shiftsSuccess: data => actionOf(SHIFTS_SUCCESS, data),
    shiftsFailure: data => actionOf(SHIFTS_FAILURE, data),
    shiftsSelected: data => actionOf(SHIFTS_SELECTED, data),

    cancelShifts: data => actionOf(CANCEL_SHIFTS, data),
    cancelShiftSuccess: data => actionOf(CANCEL_SHIFTS_SUCCESS, data),
    cancelShiftsFailure: data => actionOf(CANCEL_SHIFTS_FAILURE, data),

    loadSubscriptions: data => actionOf(LOAD_SUBSCRIPTIONS, data),
    subscriptionsSuccess: data => actionOf(LOAD_SUBSCRIPTIONS_SUCCESS, data),
    subscriptionsFailure: data => actionOf(LOAD_SUBSCRIPTIONS_FAILURE, data),

    loadTracking: data => actionOf(LOAD_TRACKING, data),
    trackingSuccess: data => actionOf(TRACKING_SUCCESS, data),
    trackingFailure: data => actionOf(TRACKING_FAILURE, data),

    loadTrackingDataForMap: data => actionOf(LOAD_TRACKING_MAP_DATA, data),
    trackingDataForMapSuccess: data =>
        actionOf(TRACKING_MAP_DATA_SUCCESS, data),
    trackingDataForMapFailure: data =>
        actionOf(TRACKING_MAP_DATA_FAILURE, data),

    loadJob: data => actionOf(LOAD_JOB, data),
    loadJobSuccess: data => actionOf(LOAD_JOB_SUCCESS, data),
    loadJobFailure: data => actionOf(LOAD_JOB_FAILURE, data),

    loadBookings: data => actionOf(LOAD_BOOKINGS, data),
    loadBookingsSuccess: data => actionOf(LOAD_BOOKINGS_SUCCESS, data),
    loadBookingsFailure: data => actionOf(LOAD_BOOKINGS_FAILURE, data),

    jobInvitations: data => actionOf(JOB_INVITATIONS, data),
    jobInvitationsSuccess: data => actionOf(JOB_INVITATIONS_SUCCESS, data),
    jobInvitationsFailure: data => actionOf(JOB_INVITATIONS_FAILURE, data),

    sendShift: data => actionOf(SEND_SHIFT, data),
    sendShiftSuccess: data => actionOf(SEND_SHIFT_SUCCESS, data),
    sendShiftFailure: data => actionOf(SEND_SHIFT_FAILURE, data),

    loadNotifications: data => actionOf(LOAD_NOTIFICATIONS, data),
    loadNotificationsSuccess: data =>
        actionOf(LOAD_NOTIFICATIONS_SUCCESS, data),
    loadNotificationsFailure: data =>
        actionOf(LOAD_NOTIFICATIONS_FAILURE, data),
    loadNotificationsCounters: query => actionOf(LOAD_NOTIFICATIONS_COUNTERS, { query }),
    loadNotificationsCountersSuccess: data =>
        actionOf(LOAD_NOTIFICATIONS_COUNTERS_SUCCESS, data),
    openNotifications: () => actionOf(OPEN_NOTIFICATIONS, {}),
    closeNotifications: () => actionOf(CLOSE_NOTIFICATIONS, {}),

    acceptInvitation: data => actionOf(ACCEPT_INVITATION, data),
    rejectInvitation: data => actionOf(REJECT_INVITATION, data),

    setSelectedJobs: data => actionOf(SET_SELECTED_JOBS, data),
    setSelectedFreelancers: data => actionOf(SET_SELECTED_FREELANCERS, data),
    setSelectedUnallocatedFreelancers: data => actionOf(SET_SELECTED_UNALLOCATED_FREELANCERS, data),

    createMassBooking: data => actionOf(CREATE_MASS_BOOKING, data),
    createMassBookingSuccess: data =>
        actionOf(CREATE_MASS_BOOKING_SUCCESS, data),
    createMassBookingFailure: data =>
        actionOf(CREATE_MASS_BOOKING_FAILURE, data),

    loadInductionSessions: data => actionOf(LOAD_INDUCTION_SESSIONS, data),
    loadInductionSessionsSuccess: data =>
        actionOf(LOAD_INDUCTION_SESSIONS_SUCCESS, data),
    loadInductionSessionsFailure: data =>
        actionOf(LOAD_INDUCTION_SESSIONS_FAILURE, data),
};

export default actions;
